import React from 'react';
import { FadeIn } from './FadeIn';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-cream overflow-hidden" data-id="element-71">
      <div className="max-w-7xl mx-auto" data-id="element-72">
        <div className="flex flex-col lg:flex-row min-h-[90vh] lg:min-h-[80vh]" data-id="element-73">
          {/* Text Content */}
          <div className="flex-1 flex items-center justify-center p-8 sm:p-12 lg:p-20 z-10" data-id="element-74">
            <div className="max-w-xl" data-id="element-75">
              <FadeIn delay={0.1} data-id="element-76">
                <span className="inline-block py-1 px-3 rounded-full bg-sage-light/20 text-sage font-medium text-sm tracking-wide mb-6" data-id="element-77">
                  Bienestar Natural
                </span>
              </FadeIn>

              <FadeIn delay={0.2} data-id="element-78">
                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif leading-tight mb-6 text-brown" data-id="element-79">
                  Alivio Integral para el Dolor Articular
                </h1>
              </FadeIn>

              <FadeIn delay={0.3} data-id="element-80">
                <h2 className="text-xl sm:text-2xl text-brown-light font-serif italic mb-10 leading-relaxed" data-id="element-81">
                  Recupera tu movilidad con estrategias naturales diarias, sin
                  fármacos fuertes.
                </h2>
              </FadeIn>

              <FadeIn delay={0.4} data-id="element-82">
                <a href="#precio" onClick={e => {
                e.preventDefault();
                document.getElementById('precio')?.scrollIntoView({
                  behavior: 'smooth'
                });
              }} className="group inline-flex items-center gap-3 bg-sage hover:bg-sage-light text-white px-8 py-4 rounded-full text-lg font-medium transition-all duration-300 shadow-sm hover:shadow-md cursor-pointer" data-id="element-83">
                  Descubre cómo
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-84" />
                </a>
              </FadeIn>
            </div>
          </div>

          {/* Image */}
          <div className="flex-1 relative min-h-[400px] lg:min-h-full" data-id="element-85">
            <FadeIn delay={0.2} direction="left" className="absolute inset-0 w-full h-full" data-id="element-86">
              <div className="absolute inset-0 bg-cream/10 z-10 mix-blend-overlay" data-id="element-87"></div>
              <img src="https://cdn.magicpatterns.com/uploads/p6TnmCJFReo2hThYo7exD5/heylloyd-image-1775606190864.png" alt="Mujer mayor descansando plácidamente" className="w-full h-full object-cover object-center" data-id="element-88" />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}